/* eslint-disable @typescript-eslint/no-unused-vars */
"use client";

import * as X from "@/ui";
import HeaderImage from "@/assets/shared-questions-header.svg";
import { Questions } from "./Questions";
import { Faq, FaqHero } from "@/providers/strapi/content/types/components/shared.component";
// import { useTravelerFaqPage } from "@/providers/strapi/content/types/singleTypes/traveler-faq-page";
import ReactMarkdown from "react-markdown";


// type Category = {
//   title: React.ReactNode;
//   subtitle: React.ReactNode;
//   questions: Array<Extract<Question, { url: string }>>;
// };

// type AudienceType = keyof typeof Audience;
type AudienceType = 'travelers' | 'retailers';

const AudienceDefault = {
  "travelers": {
    path: "/faq" as const,
    // name: {
    //   en: "Travelers",
    //   fr: "Voyageurs",
    // },
    name: ""
  },
  "retailers": {
    path: "/retail/faq" as const,
    // name: {
    //   en: "Retailers",
    //   fr: "Commerçants",
    // },
    name: ""
  },
};

// type ViewModel = {
//   travelers: {
//     path: string;
//     name: string;
//   },
//   retailers: {
//     path: string;
//     name: string
//   }
// }

const buildAudience = (faqHero: FaqHero): typeof AudienceDefault => ({
  "travelers": {
    path: "/faq" as const,
    name: faqHero.travelersTabLabel,
  },
  "retailers": {
    path: "/retail/faq" as const,
    name: faqHero.retailersTabLabel
  },
})


export function QuestionsPage(props: X.PageProps<{
  audience: AudienceType;
  categories: Faq[];
  faqHero: FaqHero;
}>) {
  // const categories = useTravelerFaqPage('categories');
  const categories = props.categories;

  return (
    <div className="flex flex-col gap-12 xl:gap-20 -mt-8 xl:mt-0 xl:mb-20">
      <Header {...props} />
      {categories.map((category, i) => (
        <section key={i} id={`c${i + 1}`} className={X.clsx(
          "scroll-mt-[120px] mx-mobile-margin xl:w-[808px] xl:mx-auto",
          "flex flex-col items-stretch"
        )}>
          <ReactMarkdown components={{
            p: ({ ...props }) => <h3 {...props} className="text-[32px] xl:text-[48px] xl:text-center mb-2 [&_strong]:font-medium leading-tight" />,
          }}>
            {category.categoryTitle}
          </ReactMarkdown>

          {/* <h4 className="text-[22px] xl:text-[30px] xl:text-center mb-4 xl:mb-10 leading-tight">{category.title}</h4> */}
          <ReactMarkdown
            components={{
              p: ({ ...props }) => <h4 {...props} className="text-[22px] xl:text-[30px] xl:text-center mb-4 xl:mb-10 leading-tight" />
            }}>
            {category.title}
          </ReactMarkdown>

          <Questions locale={props.locale} questions={category.questions} />
        </section>
      ))}

      <div className="-mt-8">
        <X.Newsletter locale={props.locale} />
      </div>
    </div>
  );
}


function Header(props: X.PageProps<{
  audience: AudienceType;
  // categories: Category[];
  categories: Faq[]
  faqHero: FaqHero
}>) {
  const tr = X.useTranslator();
  const path = X.usePathname();
  // const categories = useTravelerFaqPage('categories');
  const categories = props.categories;
  const Audience = buildAudience(props.faqHero)
  return (
    <>
      <section className={X.clsx(
        "xl:max-w-content xl:mx-auto",
        "flex flex-col-reverse xl:flex-row xl:mb-12 relative",
      )}>
        <div className={X.clsx(
          "flex-auto px-mobile-margin xl:px-0 xl:w-[500px] xl:pt-[60px]"
        )}>
          {/* <h1 className="text-[36px] xl:text-[64px] [&_strong]:font-medium mb-7 xl:mb-12">
            {tr({
              en: <>Need <strong>help?</strong></>,
              fr: <>Besoin <strong>d&apos;aide{X.Nbsp}?</strong></>,
              zh: <></>
            })}
          </h1> */}

          <ReactMarkdown components={{
            p: ({ ...props }) => <h1 {...props} className="text-[36px] xl:text-[64px] [&_strong]:font-medium mb-7 xl:mb-12" />,
            h1: ({ ...props }) => <h1 {...props} className="text-[36px] xl:text-[64px] [&_strong]:font-medium mb-7 xl:mb-12" />,
            h2: ({ ...props }) => <h1 {...props} className="text-[36px] xl:text-[64px] [&_strong]:font-medium mb-7 xl:mb-12" />,
            h3: ({ ...props }) => <h1 {...props} className="text-[36px] xl:text-[64px] [&_strong]:font-medium mb-7 xl:mb-12" />,
            h4: ({ ...props }) => <h1 {...props} className="text-[36px] xl:text-[64px] [&_strong]:font-medium mb-7 xl:mb-12" />,
          }}>
            {props.faqHero.tagLine}
          </ReactMarkdown>
          <div className="rounded-lg p-[2px] pt-[1px] xl:pt-[2px] border inline-block mb-10 xl:mb-15">
            {[Object.keys(Audience).map(audience => (
              <X.Link
                key={audience}
                href={{ pathname: Audience[audience as AudienceType].path }}
                className={X.clsx(
                  "rounded-lg px-[18px] xl:px-[22px] py-[6px] xl:py-[6px] inline-block font-light text-[11px] xl:text-[12px] leading-tight",
                  props.audience === audience && "bg-yellow font-medium",
                  "xl:hover:bg-black xl:hover:text-white xl:hover:font-medium",
                )}
              >
                {/* {tr(Audience[audience as AudienceType].name)} */}
                {Audience[audience as AudienceType].name}
              </X.Link>
            ))]}
          </div>

          <h2 className="text-[18px] xl:text-[28px] font-semibold mb-6 xl:mb-8">
            {props.faqHero.categoryListTitle}
            {/* {tr({
              en: "Choose a category",
              fr: "Choisissez une catégorie",
              zh: ""
            })} */}
          </h2>

          <div className="flex flex-row flex-wrap gap-3 xl:gap-5">
            {categories.map((category, i) => (
              <X.Link
                key={i}
                href={{ pathname: path as typeof Audience[AudienceType]["path"], hash: `#c${i + 1}` }}
                className="py-2 px-4 xl:py-1 text-[13px] xl:text-[15px] border rounded-full block hover:bg-yellow hover:border-yellow font-normal [&_strong]:font-normal"
              >
                {category.categoryLabel}
              </X.Link>
            ))}
          </div>
        </div>

        <div>
        </div>

        <X.Image
          className="w-[100%] xl:w-[760px] h-auto xl:-translate-y-[20px] xl:invisible"
          loading="eager"
          fetchPriority="high"
          priority
          src={HeaderImage}
          alt="FAQ"
        />
        <X.Image
          loading="eager"
          fetchPriority="high"
          priority
          className="w-[100%] xl:w-[832px] h-auto xl:-translate-y-[20px] hidden xl:block xl:absolute xl:top-0 xl:right-0"
          src={HeaderImage}
          alt="FAQ"
        />
      </section>
    </>
  );
}
